export enum REWARDS_URLS {
  REWARDS_LIST = '/rewards',
  REWARD_BY_ID = '/rewards/:id',
  REWARDS_FILTERED_LIST = '/rewards/filter',
  PUBLIC_REWARD = '/v1/rewards/:id/public',
  REWARD_METADATA = '/v1/rewards/:id',
  GENERATE_REWARD_TOKEN_ID = '/rewards/tokedId/generate',
  DISCOUNT_REWARD = '/rewards/discount',
  DISCOUNT_REWARD_ID = '/rewards/discount/:id',
  FREE_PRODUCT_REWARD = '/rewards/freeProduct',
  FREE_PRODUCT_REWARD_ID = '/rewards/freeProduct/:id',
  EXCLUSIVE_ACCESS_REWARD = '/rewards/exclusiveAccess',
  EXCLUSIVE_ACCESS_REWARD_ID = '/rewards/exclusiveAccess/:id',
  EVENT_REWARD = '/rewards/event',
  EVENT_REWARD_ID = '/rewards/event/:id',
  REWARD_PUBLIC_BY_CODE = 'api/v1/rewards/:code/public',
  GENERATE_EVENT_VALIDATION_CODE = '/rewards/:id/codeValidatorPassword/generate',
  DROPS = '/reward-distributions/drops',
  DROPS_CSV = 'reward-distributions/drops/csv',
  SALES = '/reward-distributions/sales',
  SALES_CSV = 'reward-distributions/sales/csv',
}
